// const SELECTOR_CLOSE_BUTTON = 'button.close';
export default () => ({

    showConfirmation: true,

    /*
    onClickClose( event ) {
        event.preventDefault();
        let trigger = event.target.closest( SELECTOR_CLOSE_BUTTON );

        // console.log( "click", { event, "target": trigger } );
        this.showConfirmation = false;
    },
    */

    init() {
        // console.log( 'Confirmation', { "this": this, "$root": this.$root, "$wire": this?.$wire, "window.Livewire": window.Livewire } );

        /* if ( window?.Livewire?.on ) {
            window.Livewire.on( "resetConfirmation", () => {
                // console.log("resetConfirmation", { arguments });
                this.showConfirmation = true;
            } );
        }*/
    }
});
